import React, { Fragment, useEffect, useState } from 'react';
import { postDataToTheServer } from '../../../helpers/api';
import AppURL from '../../../constants/AppURL';
import { nepaliMonthName } from '../../../helpers/DateFormat';
import CircleBtn from '../../../constants/CircleBtn';
import { IoReloadOutline } from "react-icons/io5";
const MemberAdvancedAmountReportCreateListView = ({ setIconsButton }: { setIconsButton: any }) => {

  const [onReportList, setOnReportList] = useState<any>([])
  const [onID, setOnID] = useState(1);
  const [isLoading, setOnLoading] = useState(false);
  const onFetchReportList = async () => {
    const formData = new FormData();
    formData.append('is_type', "2");
    setOnLoading(true);
    try {
      await postDataToTheServer(AppURL.AccountURL + "customer/mahasul/advanced/amt/report/view/", formData).then((res) => {
        setOnReportList(res);
        setOnLoading(false);
      })
    } catch (error) {
      console.log(error)
      setOnLoading(false);
    }
  }
  const onToggleReportList = () => {
    setOnID((prev) => (prev === 1 ? 2 : 1));
    onFetchReportList();
  };

  useEffect(() => {
    setIconsButton(<CircleBtn icon={<IoReloadOutline />} onClick={onToggleReportList} />);
    return () => setIconsButton(null);
  }, []);

  useEffect(() => {
    onFetchReportList();
  }, []);

  return (
    <Fragment>
      {/* <LoadingSpinner /> */}
      <div className='bg-white dark:bg-slate800 shodow rounded-md p-2'>
        <div className="relative w-full overflow-x-auto overflow-y-auto h-[80vh]">
          <table className="w-full text-sm whitespace-nowrap text-left rtl:text-right text-slate700 dark:text-slate400">
            <thead className="text-[11px] top-0 sticky z-10 font-public-sans text-slate800 capitalize border-b dark:text-slate100 dark:border-slate700">
              <tr>
                <th scope="col" className="px-2 dark:bg-slate-700 bg-slate-200 py-0.5 border border-slate-300 dark:border-gray-700 w-10">
                  S.N.
                </th>
                <th scope="col" className="px-2 dark:bg-slate-700 bg-slate-200 py-0.5 border border-slate-300 dark:border-gray-700">
                  Member Name
                </th>
                <th scope="col" className="px-2 bg-slate-200 py-0.5 border border-slate-300 dark:border-gray-700">
                  Address
                </th>
                <th scope="col" className="px-2 bg-slate-200 py-0.5 border border-slate-300 dark:border-gray-700">
                  Phone No
                </th>
                <th scope="col" className="px-2 dark:bg-slate-700 bg-slate-200 py-0.5 border border-slate-300 dark:border-gray-700">
                  Spouse Name
                </th>
                <th scope="col" className="px-2 dark:bg-slate-700 bg-slate-200 py-0.5 border border-slate-300 dark:border-gray-700">
                  Marga/Tole
                </th>
                <th scope="col" className="px-2 dark:bg-slate-700 w-10 bg-slate-200 py-0.5 border border-slate-300 dark:border-gray-700">
                  Reading Year/Month
                </th>
                <th scope="col" className="px-2 dark:bg-slate-700 bg-slate-200 py-0.5 border border-slate-300 dark:border-gray-700">
                  {onReportList?.type}
                </th>
              </tr>
            </thead>
            <tbody>
              {
                Array.isArray(onReportList?.results) && onReportList?.results?.length > 0 ? (onReportList?.results?.map((item: any, index: number) => (
                  <tr key={index} className="bg-white hover:bg-slate100 hover:cursor-pointer text-[11px] font-public-sans dark:bg-slate800 text-slate800 dark:hover:bg-slate600">
                    <td align='center' className="px-2 py-0.5 border border-slate300 dark:border-slate700">
                      {index + 1}.
                    </td>
                    <td className="px-2 py-0.5 capitalize sticky left-0 bg-white border border-slate300 dark:border-slate700 italic">
                      {`${item?.mem_name ? item?.mem_name : ""}`}
                    </td>
                    <td className="px-2 py-0.5 border border-slate300 dark:border-slate700">
                      {item?.address}
                    </td>
                    <td className="px-2 py-0.5 border border-slate300 dark:border-slate700">
                      {item?.phone_no}
                    </td>
                    <td className="px-2 py-0.5 border border-slate300 dark:border-slate700">
                      {item?.spouse_name}
                    </td>
                    <td className="px-2 py-0.5 border border-slate300 dark:border-slate700">
                      {item?.marga_tole}
                    </td>
                    <td className="px-2 py-0.5 border border-slate300 dark:border-slate700">
                      {item?.year}, {nepaliMonthName(item?.month)}
                    </td>
                    <td align='left' className="px-2 py-0.5 border border-slate300 dark:border-slate700">
                      Rs. {item?.amount}
                    </td>
                  </tr>
                ))) : <tr className="bg-white text-[12px] font-public-sans dark:bg-slate800 text-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
                  <td align='center' colSpan={16} className="px-2 py-1 border dark:border-gray-700">
                    <span>No Payroll Found</span>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </Fragment>
  )
}

export default MemberAdvancedAmountReportCreateListView